import styles from './HardwarePaymentPlans.scss';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCart } from 'src/components/Cart/UseCart';
import { useCheckout } from 'src/components/Checkout/CheckoutProvider';

import { InstallmentDetailsModal } from 'src/components/InstallmentDetailsModal/InstallmentDetailsModal';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { shouldDisplayInstallmentPlans } from 'src/services/dcs/bundle';
import { Installments, Plans } from '../types';
import { PlanSelect } from './PlanSelect';

export const HardwarePaymentPlans: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const { selectedPurchaseType, setSelectedPurchaseType } = useCheckout();
  const { checkout } = useCart();

  const plans: Plans = [
    {
      term: Installments.P,
      price: checkout.subtotal,
    },
    ...checkout.installmentPlans.map(plan => ({
      term: plan.id as any,
      price: plan.cost,
    })),
  ];

  const oneTimePayment = plans.find(plan => plan.term === 'P');
  const installmentPlans = plans.filter(plan => plan !== oneTimePayment);
  const displayInstallmentPlans = shouldDisplayInstallmentPlans(checkout.subtotal);

  return (
    <>
      <form className={styles.options} data-test="form">
        {oneTimePayment && (
          <PlanSelect
            onChange={() => setSelectedPurchaseType(oneTimePayment.term)}
            checked={oneTimePayment.term === selectedPurchaseType}
            key={oneTimePayment.term}
            plan={oneTimePayment}
            id={`plan-select-P`}
          />
        )}
        {displayInstallmentPlans && installmentPlans.map(plan => (
          <PlanSelect
            onChange={() => setSelectedPurchaseType(plan.term)}
            checked={plan.term === selectedPurchaseType}
            key={plan.term}
            plan={plan}
            id={`plan-select-${plan.term}`}
          />
        ))}
      </form>
      {displayInstallmentPlans && (
        <>
          <TextV2
            tagName="button"
            variant="body-small"
            className={styles.installmentLink}
            value={t('order-summary.installments-details-link')}
            onClick={() => setIsOpen(!isOpen)}
          />
          <InstallmentDetailsModal modalState={[isOpen, () => setIsOpen(!isOpen)]} />
        </>
      )}
    </>
  );
};

HardwarePaymentPlans.displayName = 'HardwarePaymentPlans';
